import { ManagementIndexPage } from ".";
import { ElLoading } from "element-plus";
import storage from "@/storage";
import { Options } from "vue-class-component";
import components from "../../components/component";
import { alert } from "@cems-eco/core/src/utils/widget";


@Options({
    components,
})
export class BoxManagementIndexPage extends ManagementIndexPage {

    async mounted() {
        const loader = ElLoading.service({ lock: true });

        try {
            const site = storage.getSync<any>(storage.SITE);
            this.management = await this.managementBloc.getManagementByClient(site.client_id);
            this.updateDatetimeInput();
            await this.checkPermission();
            
            loader.close();
        } catch (error) {
            loader.close();
            await alert('Oopps!', 'Something went wrong. Please contact administrator', 'error');
            this.$router.back();
        }
    }

}

